import { apiSlice } from '../../../store/api/apiSlice';
import type {
  CreateOutOfOfficeRequest,
  DeleteOutOfOfficeRequest,
  OutOfOfficeBlock,
} from './outOfOfficeTypes';

export const outOfOfficeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOutOfOffice: builder.query<OutOfOfficeBlock[], void>({
      query: () => '/calendar/out-of-office',
      providesTags: ['CalendarSettings'],
    }),
    createOutOfOffice: builder.mutation<OutOfOfficeBlock, CreateOutOfOfficeRequest>({
      query: (body) => ({
        url: '/calendar/out-of-office',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CalendarSettings'],
    }),
    deleteOutOfOffice: builder.mutation<null, DeleteOutOfOfficeRequest>({
      query: ({ id }) => ({
        url: `/calendar/out-of-office/${encodeURIComponent(id)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CalendarSettings'],
    }),
  }),
});

export const {
  useGetOutOfOfficeQuery,
  useCreateOutOfOfficeMutation,
  useDeleteOutOfOfficeMutation,
} = outOfOfficeApi;
